const PRELOAD_IMAGES = [
    '/images/BackgroundTrack.png',
    '/images/Bubble_Idle.png',
    '/images/card-heart.png',
    '/images/card_dummy.png',
    '/images/Lock.svg',
    '/images/Logo.png',
    '/images/LogoStacked.png',
    '/images/Pattern5.png',
    '/images/PowerUpCoin.png',
    '/images/PowerupsBatterie.png',
    '/images/PowerUpShield.png',
    '/images/PowerupsStar.png',
    '/images/Round_Electric.gif',
    '/images/TipIcons.png',
    '/images/battery.png',
    '/images/shield.png',
    '/images/star.png',
    '/images/supernova.png',

    '/images/banner/ChameleonInfoBanner.png',
    '/images/buttons/ReadyText.svg',
    '/images/cloud/CloudMask.svg',

    '/images/countdown/Countdown1.png',
    '/images/countdown/Countdown2.png',
    '/images/countdown/Countdown3.png',
    '/images/countdown/Lauf.png',

    '/images/editor/Cloud.svg',
    '/images/editor/Color Choice Blue.png',
    '/images/editor/Color Choice Green.png',
    '/images/editor/Color Choice Multi.png',
    '/images/editor/Color Choice Red.png',
    '/images/editor/Item_Bow.png',
    '/images/editor/Item_Wings.png',
    '/images/editor/Item_schnellebrille.png',
    '/images/editor/Leaf.svg',
    '/images/editor/Overlay.png',
    '/images/editor/Property 1=Dust.png',
    '/images/editor/Property 1=Leaf.png',
    '/images/editor/Property 1=Rainbow.png',
    '/images/editor/boots.png',
    '/images/editor/gloves.png',
    '/images/editor/helmet.png',
    '/images/editor/vest.png',

    '/images/hands/State=Point.png',

    '/images/hearts/Default.png',
    '/images/hearts/Empty.png',
    '/images/hearts/Shielded.png',

    '/images/loadingBar/Chamele.svg',
    '/images/loadingBar/LoaderCup.svg',
    '/images/loadingBar/LoaderElephant.svg',
    '/images/loadingBar/LoaderPen.svg',
    '/images/loadingBar/LoaderUfo.svg',

    '/images/parentsLanding/background.png',
    '/images/parentsLanding/card-background.png',
    '/images/parentsLanding/card-frame.png',

    '/images/powerups/PowerUp_Batterie_Shift.png',
    '/images/powerups/PowerUp_Coin_Shift.png',
    '/images/powerups/PowerUp_Shield_Shift.png',
    '/images/powerups/PowerUp_Star_Shift.png',

    '/images/tutorial/hintarrow.png',
    '/images/tutorial/shine.png',
]

const MAX_PARALLEL_DOWNLOADS = 2

function loadImage(src: string) {
    return new Promise<void>((resolve) => {
        const image = new Image()
        // A failed decorative image must not hold the queue up
        image.addEventListener('load', () => resolve(), { once: true })
        image.addEventListener('error', () => resolve(), { once: true })
        image.src = src
    })
}

export function preloadImages() {
    let nextIndex = 0

    const worker = async () => {
        while (nextIndex < PRELOAD_IMAGES.length) {
            const src = PRELOAD_IMAGES[nextIndex]
            nextIndex += 1
            await loadImage(src)
        }
    }

    void Promise.all(
        Array.from({ length: MAX_PARALLEL_DOWNLOADS }, worker),
    )
}
